export const createStyles = (theme?: any) => ({
  modal: {
    width: 'clamp(343px, calc(100vw - 64px), 560px)',
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: 'calc(100vh - 32px)',
    bgcolor: 'background.paper',
    borderRadius: theme?.shape?.borderRadius ?? 8,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    pt: '16px',
    pr: '16px',
    pb: '24px',
    pl: '16px',
    outline: 'none',
    overflowY: 'auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: '16px',
  },
  modalTitle: {
    fontFamily: theme?.typography?.fontFamily,
    fontWeight: theme?.typography?.fontWeightMedium ?? 500,
    fontStyle: 'normal',
    fontSize: '1.25rem',
    lineHeight: '160%',
    letterSpacing: '0.15px',
  },
  closeIcon: { color: 'text.secondary' },
  alert: {
    '& .MuiAlert-action': { display: 'none' },
    '& .MuiAlert-message': { flex: 1, overflow: 'visible' },
    // Align the icon visually with the first line of the alert title.
    '& .MuiAlert-icon': { transform: 'translateY(2px)' },
  },
  alertTitle: {
    display: 'block',
    fontFamily: theme?.typography?.fontFamily,
    fontWeight: theme?.typography?.fontWeightMedium ?? 500,
    fontStyle: 'normal',
    fontSize: '1rem',
    lineHeight: '150%',
    letterSpacing: '0.15px',
  },
  message: {
    display: 'block',
    fontFamily: theme?.typography?.fontFamily,
    fontWeight: theme?.typography?.fontWeightRegular ?? 400,
    fontStyle: 'normal',
    fontSize: '0.875rem',
    lineHeight: '143%',
    letterSpacing: '0px',
  },
  actions: { display: 'flex', justifyContent: 'flex-end', mt: '16px' },
});
